import "bootstrap/dist/css/bootstrap.min.css";
import { addLocale, FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { InputTextarea } from 'primereact/inputtextarea';
import React, { useEffect, useRef, useState } from 'react';
import Cookies from 'universal-cookie/es6';
import apis from '../../api';
import '../../DataTableDemo.css';
import useParamsLicense from '../../helpers/useParamsLicense';
import dateFormat from '../../services/DateFormat.service';
import invDateFormat from '../../services/InvertDateFormat.service';
import ConfBar from '../ConfBar/ConfBar';
import { LabelField } from './Licenses.styles';
import { InputNumber } from 'primereact/inputnumber';
import Video from '../Video/Video';
import { tableDate, timeToDate } from "../../services/tableDate.service";
import SkeletonTable from "../SkeletonTable/SkeletonTable";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { excelReport } from "../../services/excelReport.service";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Licenses
Description : Tabla para la creación de ausentismos.
Date Autor Modification
================================================================================
27/10/2021 Santiago Coca Rojas Creación – Se implementa la tabla desde cero.
02/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente teniendo los cambios realizados con PrimeReact
================================================================================ */

export default function Licenses() {

  /*Listas de valores del componente*/
  const [listaContingencia, setListaContingencia] = useState([]);
  const [listaCodEmpleado, setListaCodEmpleado] = useState([]);
  const [listaCalendario, setListaCalendario] = useState([]);
  const [listaProrrogas, setListaProrrogas] = useState([]);
  const [listaDiagnostico, setListaDiagnostico] = useState([]);
  const [listasCargadas, setListasCargadas] = useState(false)

  /*Propiedades del componente*/
  const [codEmpleado, setCodEmpleado] = useState("");
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [contingencia, setContingencia] = useState("");
  const [tiempo, setTiempo] = useState("");
  const [calendario, setCalendario] = useState("");
  const [idLicencia, setIdLicencia] = useState("");
  const [prorroga, setProrroga] = useState("");
  const [diagnostico, setDiagnostico] = useState("");
  const [observaciones, setObservaciones] = useState("")
  const [historico, setHistorico] = useState([])

  /*Otras propiedades*/
  const [params] = useParamsLicense();
  const [listaFechas, setListaFechas] = useState("");
  const [listaContingencia2, setListaContingencia2] = useState([]);

  const [rowId, setRowId] = useState(0);

  /*Propiedades de los modales del componente*/
  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpen_, setIsOpen_] = React.useState(false);
  const [isOpenEliminar, setIsOpenEliminar] = React.useState(false);
  const [isOpenH, setIsOpenH] = React.useState(false);

  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);
  const [loadPage, setLoadPage] = useState(false)

  /*Constantes globales para el componente*/
  const headers = {
    authorization: localStorage.getItem('token')
  }

  /*Propiedades de la tabla del componente*/
  const [rowData, setRowData] = useState([]);
  const [rows, setRows] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(10);
  const [selectedRows, setSelectedRows] = useState(null);
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState('');
  const elementWidth = { width: "20rem", justifySelf: "center" }

  const toast = useRef(null);

  /*Formato para el calendario del componente*/
  addLocale('es', {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
    monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
    today: 'Hoy',
    clear: 'Claro'
  });

  useEffect(() => {
    /*Se cargan los datos de las listas de valores y de la tabla del componente*/
    setTabla();
  }, [rowId]);

  useEffect(() => {
    /*Carga la lista de ausentismos que pueden ser prorrogados*/
    const getExtensions = async () => {
      let _codEmpleado = ""
      let _contingencia = ""
      if (codEmpleado.length) {
        _codEmpleado = codEmpleado
        _contingencia = contingencia
      }
      else {
        _codEmpleado = codEmpleado.CODE
        _contingencia = contingencia ? contingencia.CODE : ""
      }
      console.log(codEmpleado)
      try {
        await apis.getLicenseExtension(localStorage.getItem('entity'), localStorage.getItem('client'), _codEmpleado, _contingencia, headers).then(res => {
          let lista = res.data["EXTENCION"]
          setListaProrrogas(lista)
        })
      }
      catch (err) {
        console.log("Wait")
      }
    }
    getExtensions()
  }, [contingencia])

  useEffect(() => {
    const historicTemplate = async () => {
      /*Se inicializan las propiedades del componente para la generación de reportes*/
      let plantilla = []
      params.forEach((p, index) => {
        if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
          plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
        }
        else {
          plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
        }
      })
      setHistorico(plantilla)
    }
    historicTemplate()
  }, [params]);

  /*Funciones que manejan el comportamiento de la tabla del componente*/
  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  }

  const template2 = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 }
      ];

      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por página: </span>
          <Dropdown className="sel" value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </React.Fragment>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    }
  };

  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Agregar" icon="pi pi-plus" className="p-button-success mr-2 p-button-sm" onClick={() => showModal()} />
        <Button label="Reporte histórico" icon="pi pi-file-excel" className="p-button-sucess mr-2 p-button-sm" onClick={() => showModalH()} />
      </React.Fragment>
    )
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <div>
        <Button icon="pi pi-pencil" className="p-button-warning mr-2 p-button-sm text-xs" tooltip="Actualizar ausentismo" tooltipOptions={{ position: 'top' }} onClick={() => { setIdLicencia(rowData["ID"]); initializeData(rowData) }} />
        <Button icon="pi pi-trash" className="p-button-danger mr-2 p-button-sm text-xs" tooltip="Eliminar ausentismo" tooltipOptions={{ position: 'top' }} onClick={() => { setIdLicencia(rowData["ID"]); showModalEliminar() }} />
      </div>
    )
  }

  const renderHeader1 = () => {
    return (
      <div className="flex justify-content-between">
        <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText className="p-inputtext-sm" value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" />
        </IconField>
      </div>
    )
  }

  const onGlobalFilterChange1 = (e) => {
    /*Filtro global de la tabla*/
    const value = e.target.value;
    let _filters1 = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
    _filters1['global'].value = value;

    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  }

  const clearFilter1 = () => {
    initFilters1();
  }

  const initFilters1 = () => {
    /*Filtros de la tabla del componente*/
    setFilters1({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NUMBER_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'START_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'END_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'CONTINGENCY': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'TIME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'CALENDAR': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'EXTENSION': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
    });
    setGlobalFilterValue1('');
  }

  const header1 = renderHeader1();

  const matchModes = [
    { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
  ];

  /*Funciones que manejan el comportamiento de los modales del componente*/
  const showModal = () => {
    if (!listasCargadas) {
      setListas()
    }
    setIsOpen(true);
  };

  const hideModal = () => {
    setIsOpen(false);
    limpiar();
  };

  const showModal_ = () => {
    setIsOpen_(true);
  };

  const hideModal_ = () => {
    setIsOpen_(false)
    limpiar()
  };

  const showModalEliminar = () => {
    setIsOpenEliminar(true);
  };

  const hideModalEliminar = () => {
    setIsOpenEliminar(false)
  };

  const showModalH = () => {
    setIsOpenH(true);
  };

  const hideModalH = () => {
    setIsOpenH(false);
  };

  async function limpiar() {
    setCodEmpleado("");
    setContingencia("");
    setTiempo("");
    setIdLicencia("");
    setCalendario("");
    setFechaInicio("");
    setFechaFin("")
    setProrroga("")
    setDiagnostico("")
    setObservaciones("")
  }

  const GetCalendar = async (contract = "") => {
    await apis.getNoveltiesCalendar(contract, headers).then(res => {
      let lista = res.data["CALENDAR"]
      setListaCalendario(lista)
    })
  }

  async function setListas() {
    GetCalendar()
    await apis.getLicensesLists(localStorage.getItem("entity"), localStorage.getItem("client"), headers).then(res => {
      let codsEmpleados = res.data["CONTRACTS"]
      let contingencias = res.data["CONTINGENCY"]//Code, Name
      let diagnosticos = res.data["DIAGNOSTICOS"]//Code, Name
      setListaContingencia(contingencias);
      setListaCodEmpleado(codsEmpleados);
      setListaDiagnostico(diagnosticos);
      setListasCargadas(true)
    })
  }

  async function setTabla() {
    /*Función encargada de cargar la información de la tabla del componente*/
    try {
      await apis.getLicenses(localStorage.getItem('entity'), localStorage.getItem('client'), "NULL", headers).then(res => {
        if (res.data["ABSENCE"].length > 0) {
          let data = res.data["ABSENCE"]
          let contenidoTabla = []
          let contenidoListaFechas = []
          let contenidoContingencias = []
          data.forEach(element => {
            console.log(element)
            let contingencia = element["CONTINGENCY"].split("|")
            let calendario = element["ID_CALENDAR"].split("|")
            let datos = element["NAME"].split("|")
            let prorrogas = element["EXTENSION"].split("|")
            let diagnostico = element["DIAGNOSTIC"].split("|")
            let fechaInicio = tableDate(element.START_DATE)
            let fechaFin = tableDate(element.END_DATE)
            contenidoContingencias.push({ "value": '' + contingencia[0] + '', "label": '' + contingencia[1] + '' })
            contenidoListaFechas.push({ inicio: invDateFormat(element.START_DATE), fin: invDateFormat(element.END_DATE) })
            contenidoTabla.push({
              ID: element.ABSENCE_ID, CONTRACT_ID: element.CONTRACT_ID, NUMBER_ID: datos[0],
              NAME: datos[1], START_DATE: fechaInicio, END_DATE: fechaFin, CONTINGENCY_ID: contingencia[0],
              CONTINGENCY: contingencia[1], TIME: element.DAYS, CALENDAR_ID: calendario[0],
              CALENDAR: calendario[1], EXTENSION_ID: prorrogas[0], EXTENSION: prorrogas[1],
              FORMAT_START_DATE: invDateFormat(element.START_DATE), FORMAT_END_DATE: invDateFormat(element.END_DATE),
              DIAGNOSTIC_ID: diagnostico[0], DIAGNOSTIC: diagnostico[1], OBSERVATIONS: element.OBSERVATIONS
            })
          })
          setListaContingencia2(contenidoContingencias)
          setListaFechas(contenidoListaFechas)
          setRowData(contenidoTabla)
          setRows(contenidoTabla)
          setLoadPage(true)
        }
        else {
          setRows([])
          setRowData([])
          setLoadPage(true)
        }
      })
    }
    catch (err) {
      setLoadPage(true)
    }
  }

  async function postLicense() {

    /*Función ecargada de guardar el ausentismo en la base de datos */
    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _codEmpleado = codEmpleado.CODE;
    const _fechaInicio = dateFormat(fechaInicio);
    const _contingencia = contingencia.CODE;
    const _tiempo = tiempo;
    const _calendario = calendario.ID_CALENDAR;
    const _prorroga = prorroga.CODE
    const _diagnostico = diagnostico.detail_id
    const _observaciones = observaciones

    let _fechaFin = ""

    await apis.getLicenseEndDate(_entity, _cliente, _fechaInicio, _tiempo, _codEmpleado, headers).then(res => {
      _fechaFin = res.data["END_DATE"]
    })

    const license = {
      CLIENT: _cliente,
      ENTITY: _entity,
      ID_CALENDAR: _calendario,
      START_DATE: _fechaInicio,
      END_DATE: _fechaFin,
      DAYS: _tiempo,
      CONTRACT_ID: _codEmpleado,
      CONTINGENCY: _contingencia,
      EXTENSION: _prorroga,
      DIAGNOSTIC: _diagnostico,
      OBSERVATIONS: _observaciones
    }

    try {
      await apis.postLicenses(license, headers).then(res => {
        setLoading1(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Ausentismo agregado exitosamente' });
      })
      setTabla();
      limpiar();
      hideModal();
    } catch (err) {
      setLoading1(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  async function putLicense() {

    /*Función encargada de actualizar el ausentismo en la base de datos*/
    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _idLicencia = idLicencia
    const _codEmpleado = codEmpleado
    const _fechaInicio = dateFormat(fechaInicio);
    const _tiempo = tiempo;
    const _contingencia = contingencia
    const _calendario = calendario;
    const _prorroga = prorroga.CODE;
    const _diagnostico = diagnostico ? diagnostico.detail_id : ""
    const _observaciones = observaciones

    let _fechaFin = ""

    await apis.getLicenseEndDate(_entity, _cliente, _fechaInicio, _tiempo, _codEmpleado, headers).then(res => {
      _fechaFin = res.data["END_DATE"]
    })

    const license = {
      CLIENT: _cliente,
      ENTITY: _entity,
      ID_CALENDAR: _calendario,
      START_DATE: _fechaInicio,
      END_DATE: _fechaFin,
      DAYS: _tiempo,
      CONTRACT_ID: _codEmpleado,
      CONTINGENCY: _contingencia,
      ABSENCE_ID: _idLicencia,
      EXTENSION: _prorroga,
      DIAGNOSTIC: _diagnostico,
      OBSERVATIONS: _observaciones
    }

    try {
      await apis.putLicenses(license, headers).then(res => {
        setLoading2(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Ausentismo actualizado exitosamente' });
      })
      setTabla();
      limpiar();
      hideModal_();
    } catch (err) {
      setLoading2(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  async function deleteLicense() {

    /*Función encargada de eliminar el ausentismo en la base de datos */
    const _cliente = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity')
    const _idLicencia = idLicencia

    try {
      await apis.deleteLicenses(_entity, _cliente, _idLicencia, headers).then(res => {
        setLoading3(false)
        toast.current.show({ severity: 'info', summary: 'Info', detail: 'Ausentismo eliminado exitosamente' });
      })
      setTabla();
      hideModalEliminar();
      limpiar();
    } catch (err) {
      setLoading3(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  async function postLicenseHistoryReport() {

    /*Función encargada de cargar la informacion para generar el reporte de histótico de ausentismos*/
    let finalReport = []
    const client = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const option = "1"
    let report = {
      CLIENT: client,
      ENTITY: _entity,
      OPTION: option,
      REPORTS: []
    }
    let max = 0
    historico.forEach(h => {
      let size = h.SHEET.length
      if (size > max) {
        max = size
      }
    })
    for (let i = 0; i < max; i++) {
      report.REPORTS.push({ PARAMETERS: [] })
    }

    historico.forEach(h => {
      h.SHEET.forEach(e => {
        report.REPORTS[e].PARAMETERS.push({ LABEL: h.LABEL, VALUE: h.CODE })
      })
    })
    try {
      await apis.postReportLicenseHistory(report, headers).then(res => {
        finalReport = res.data
        excelReport(finalReport, 'reporteHistoricoAusentismos')
        setLoading4(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte histórico de ausentismos generado existosamente" });
        hideModalH();
      })
    }
    catch (err) {
      setLoading4(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  function initializeData(rowData) {
    /*Función encargada de inicializar las propiedades del componente con los valores de el ausentismo seleccionado*/
    setIdLicencia(rowData.ID)
    setCodEmpleado(rowData.CONTRACT_ID)
    setFechaInicio(rowData.START_DATE)
    setFechaFin(rowData.END_DATE)
    setTiempo(rowData.TIME);
    setCalendario(rowData.CALENDAR_ID);
    setContingencia(rowData.CONTINGENCY_ID);
    setFechaInicio(rowData.FORMAT_START_DATE);
    setFechaFin(rowData.FORMAT_END_DATE);
    setProrroga({ CODE: rowData.EXTENSION_ID, NAME: rowData.EXTENSION })
    setDiagnostico(rowData.DIAGNOSTIC)
    showModal_();
  }

  /*Headers y footers de los modales del componente*/
  const addFooter = (
    <div>
      <Button onClick={() => { setLoading1(false); hideModal() }}>Cancelar</Button>
      <Button label="Guardar" loading={loading1} onClick={() => { setLoading1(true); postLicense() }} />
    </div>
  );

  const addHeader = (
    <div>
      <h3>Agregar ausentismos</h3>
    </div>
  )

  const updateFooter = (
    <div>
      <Button onClick={() => { setLoading2(false); hideModal_() }}>Cancelar</Button>
      <Button label="Guardar" loading={loading2} onClick={() => { setLoading2(true); putLicense() }} />
    </div>
  );

  const updateHeader = (
    <div>
      <h3>Actualizar ausentismos</h3>
    </div>
  )

  const deleteFooter = (
    <div>
      <Button onClick={() => { setLoading3(false); hideModalEliminar() }}>Cancelar</Button>
      <Button label="Si" loading={loading3} onClick={() => { setLoading3(true); deleteLicense() }} />
    </div>
  );

  const deleteHeader = (
    <div>
      <h3>¿Desea eliminar el ausentismo?</h3>
    </div>
  )

  const footerHS = (
    <div>
      <Button label='Generar' loading={loading4} onClick={() => { setLoading4(true); postLicenseHistoryReport() }} />
    </div>
  );

  const headerHS = (
    <div>
      <h3>Parámetros reporte histórico de ausentismos</h3>
    </div>
  )

  /*Funciones que manejan el cambio en los campos de entrada del modal de gneración del reporte*/
  function handleChangeH(e, d, index) {
    setHistorico(h => {
      let newHistorico = [...h]
      console.log(index)
      console.log(h)
      newHistorico[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newHistorico
    })
  }

  async function handleChangeDateH(e, d, index) {
    console.log(e.value)
    let date = dateFormat(e.value)
    setHistorico(h => {
      let newHistorico = [...h]
      newHistorico[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newHistorico
    })
  }

  async function handleChangeTextH(e, d, index) {
    console.log(e.value)
    setHistorico(h => {
      let newHistorico = [...h]
      newHistorico[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newHistorico
    })
  }

  const iniDateTemplate = (rowData) => {
    const date = timeToDate(rowData.START_DATE);
    return date
  }

  const endDateTemplate = (rowData) => {
    const date = timeToDate(rowData.END_DATE);
    return date
  }

  /*Renderizado del componente*/
  return (
    <div>
      <div className="surface-100	 px-4 py-5 md:px-6 lg:px-8">
        <Toast ref={toast} />
        <Dialog header={addHeader} footer={addFooter} visible={isOpen}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
          <LabelField htmlFor="label">Código empleado</LabelField>
          <Dropdown filter showClear filterBy="NAME" style={elementWidth} value={codEmpleado} options={listaCodEmpleado} placeholder={"Seleccione un Empleado"}
            onChange={(e) => { setCodEmpleado(e.value); GetCalendar(e.value) }} optionLabel="NAME" />
          <LabelField htmlFor="label">Calendario</LabelField>
          <Dropdown style={elementWidth} value={calendario} autoFocus disabled={!codEmpleado}
            filter showClear filterBy="DETAIL" emptyMessage={"No hay calendarios disponibles"}
            options={listaCalendario} placeholder={"Seleccione calendario"}
            onChange={(e) => {
              setCalendario(e.value)
            }}
            optionLabel="DETAIL"
          />
          <LabelField htmlFor="label">Fecha inicio</LabelField>
          <Calendar style={elementWidth} id="navigators" value={fechaInicio}
            onChange={(e) => setFechaInicio(e.value)} disabled={!codEmpleado}
            locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaInicio}
            yearRange="2010:2030"
          />
          <LabelField htmlFor="label">Contingencia</LabelField>
          <Dropdown style={elementWidth} value={contingencia} disabled={!codEmpleado}
            filter showClear filterBy="NAME" emptyMessage={"No hay contingencias disponibles"}
            options={listaContingencia} placeholder={"Seleccione contingencia"}
            onChange={(e) => {
              setContingencia(e.value)
            }}
            optionLabel="NAME"
          />

          {contingencia && (contingencia.EXTENSION === "1") ?
            <>
              <LabelField htmlFor="label">Prórroga</LabelField>
              <Dropdown style={elementWidth} value={prorroga} disabled={!codEmpleado}
                filter showClear filterBy="NAME" emptyMessage={"No hay prórrogas disponibles"}
                options={listaProrrogas} placeholder={"Seleccione la prórroga"}
                onChange={(e) => {
                  setProrroga(e.value)
                }}
                optionLabel="NAME"
              />
            </>
            : null}

          <LabelField htmlFor="label">Tiempo</LabelField>
          <InputNumber
            min={0}
            style={elementWidth}
            maxLength={7}
            id="label2"
            value={tiempo}
            placeholder="Tiempo"
            disabled={!codEmpleado}
            onChange={(e) => setTiempo(e.value)}
          />
          <LabelField htmlFor="label">Diagnóstico (Sólo aplica para incapacidades)</LabelField>
          <Dropdown style={elementWidth} value={diagnostico} disabled={!codEmpleado}
            filter showClear filterBy="description" emptyMessage={"No hay contingencias disponibles"}
            options={listaDiagnostico} placeholder={"Seleccione diagnóstico"}
            onChange={(e) => {
              setDiagnostico(e.value)
            }}
            optionLabel="description"
          />
          <LabelField htmlFor="label">Observaciones</LabelField>
          <InputTextarea maxLength={70} value={observaciones} onChange={(e) => setObservaciones(e.target.value)} rows={4} cols={30} style={elementWidth} disabled={!codEmpleado} />
        </Dialog>
        <Dialog header={updateHeader} footer={updateFooter} visible={isOpen_}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal_}>
          <LabelField htmlFor="label">Fecha inicio</LabelField>
          <Calendar style={elementWidth} id="navigators" value={fechaInicio}
            onChange={(e) => setFechaInicio(e.value)}
            locale="es" dateFormat="dd-mm-yy" showIcon placeholder={fechaInicio}
            yearRange="2010:2030"
          />
          {contingencia === "1053" || contingencia === "1061" ?
            <>
              <LabelField htmlFor="label">Prórroga</LabelField>
              <Dropdown style={elementWidth} value={prorroga}
                filter showClear filterBy="NAME" emptyMessage={"No hay prórrogas disponibles"}
                options={listaProrrogas} placeholder={"Seleccione prórroga"}
                onChange={(e) => {
                  setProrroga(e.value)
                }}
                optionLabel="NAME"
              />
            </>
            : null}
          <LabelField htmlFor="label">Tiempo</LabelField>
          <InputNumber
            min={0}
            style={elementWidth}
            maxLength={7}
            id="label2"
            value={tiempo}
            placeholder="Tiempo"
            onChange={(e) => setTiempo(e.value)}
          />
        </Dialog>
        <Dialog header={deleteHeader} footer={deleteFooter} visible={isOpenEliminar}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalEliminar}>
        </Dialog>
        <Dialog header={headerHS} footer={footerHS} visible={isOpenH} bo
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalH}>
          <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
          {params.map((d, index) => {
            /*Generación dinámica de los parámetros para la generación del reporte histórico de ausentismos*/
            if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && historico.length > 0 && typeof historico[index] !== "undefined") {
              let label = d.LABEL;
              if (d.REQUIRED === "1") {
                label = label + "*"
              }
              switch (d.TYPE) {
                case "LIST":
                  let options = []
                  if (d.REQUIRED === "1") {
                    options = [...d.OPTIONS]
                  }
                  else {
                    options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                  }
                  return (<>
                    <LabelField htmlFor="label">{label}</LabelField>
                    <Dropdown
                      key={index}
                      style={elementWidth}
                      value={historico[index]["NAME"]}
                      options={options}
                      filter showClear filterBy="NAME"
                      optionLabel="NAME"
                      emptyMessage={"No hay " + label + "s disponibles"}
                      //optionTemplate={optionTemplate}
                      placeholder={historico[index]["NAME"] ? historico[index]["NAME"] : "Seleccione"}
                      onChange={(e) => handleChangeH(e, d, index)}
                    />
                  </>
                  );
                case "DATE":
                  return (<>
                    <LabelField htmlFor="label">{label}</LabelField>
                    <Calendar key={d} style={elementWidth} id="navigators" value={historico[index]}
                      onChange={(e) => handleChangeDateH(e, d, index)}
                      locale="es" dateFormat="dd-mm-yy" showIcon placeholder="Seleccione"
                      yearRange="2010:2030" /></>
                  );
                default:
                  return (<>
                    <LabelField htmlFor="label">{label}</LabelField>
                    <InputText
                      key={d}
                      style={elementWidth}
                      id="label2"
                      type="text"
                      value={historico[index]}
                      onChange={(e) => handleChangeTextH(e, d, index)}
                    /></>
                  )
              }
            }
          })}
        </Dialog>
        <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-2">
          <span className="text-900">Ausentismos y licencias</span>
          <Video header="Instructivo proceso novedades" url={localStorage.getItem('NOVELTIESLICENSES_VIDEO')} />
        </div>
        <ConfBar style={{ marginTop: "-2rem" }} />
        <div className="card mt-4">
          <SkeletonTable load={loadPage}>
            <Toolbar className="mb-4" start={leftToolbarTemplate}></Toolbar>
            <DataTable className="text-xs" value={rows} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
              selection={selectedRows} onSelectionChange={(e) => setSelectedRows(e.value)} dataKey="ID"
              size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['CONTRACT_ID', 'NUMBER_ID', 'NAME', 'CONCEPT', 'UNIT', 'CALENDAR', 'EXTENSION']}
              header={header1} >
              <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
              <Column field="CONTRACT_ID" header="Contrato" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por contrato" sortable></Column>
              <Column field="NUMBER_ID" header="Identificación" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Identificación" sortable></Column>
              <Column field="NAME" header="Nombre" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
              <Column field="START_DATE" header="Fecha inicio" body={iniDateTemplate} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha inicio" sortable></Column>
              <Column field="END_DATE" header="Fecha fin" body={endDateTemplate} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha fin " sortable></Column>
              <Column field="CONTINGENCY" header="Contingencia" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por contingencia" sortable></Column>
              <Column field="TIME" header="Tiempo" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por tiempo" sortable></Column>
              <Column field="EXTENSION" header="Prórroga" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por tiempo" sortable></Column>
              <Column field="CALENDAR" header="Calendario" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por calendario" sortable></Column>
              <Column field="DIAGNOSTIC" header="Diagnóstico" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por tiempo" sortable></Column>
              <Column field="OBSERVATIONS" header="Observaciones" showFilterOperator={false} filterMatchModeOptions={matchModes} bodyStyle={{ maxWidth: "12rem" }} filter filterPlaceholder="Buscar por tiempo" sortable></Column>
              <Column header="Acciones" headerStyle={{ width: '8rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
            </DataTable>
          </SkeletonTable>
        </div>
      </div>
    </div>
  );
}